module.exports = __webpack_public_path__ + "img/engineeringCases33.bb542d87.jpg";